import * as React from 'react';

const SvgGps = (props) => (
  <svg
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='M16 27C9.933 27 5 22.067 5 16S9.933 5 16 5s11 4.933 11 11-4.933 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z'
      fill='currentColor'
    />
    <path
      d='M16 21c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm0-8c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3ZM16 6.333c-.547 0-1-.453-1-1V2.667c0-.547.453-1 1-1 .547 0 1 .453 1 1v2.666c0 .547-.453 1-1 1ZM5.33 17H2.665c-.547 0-1-.453-1-1 0-.547.453-1 1-1h2.667c.546 0 1 .453 1 1 0 .547-.454 1-1 1ZM16 30.333c-.547 0-1-.453-1-1v-2.666c0-.547.453-1 1-1 .547 0 1 .453 1 1v2.666c0 .547-.453 1-1 1ZM29.33 17h-2.666c-.547 0-1-.453-1-1 0-.547.453-1 1-1h2.667c.546 0 1 .453 1 1 0 .547-.454 1-1 1Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgGps;
